import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Service, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {ReleaseSummary} from '../orders/release/release-summary';
import {ReleaseSummarySearchCriteria} from '../orders/release/release-summary-search-criteria';
import {GoogleService} from './google-service';

@Service()
export class ReleaseSummaryService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public getReleases(criteria: ReleaseSummarySearchCriteria): Observable<ReleaseSummary[]> {
    let url = this.urlBase + 'releaseSummary';
    let body = JSON.stringify(criteria);
    return this.http.post<ReleaseSummary[]>(url, body, {headers: this.getPostHeaders()});
  }

  public getRecentReleases(criteria: ReleaseSummarySearchCriteria): Observable<ReleaseSummary[]> {
    let url = this.urlBase + 'releaseSummary/recentReleases';
    let body = JSON.stringify(criteria);
    return this.http.post<ReleaseSummary[]>(url, body, {headers: this.getPostHeaders()});
  }

  public getRecentReleasesTemplate(orgUnitId: string): Observable<Blob> {
    let url = this.urlBase + 'releaseSummary/recentReleases/template';
    if (orgUnitId && orgUnitId.length > 0) {
      url = url + '?orgUnitId=' + orgUnitId;
    }
    return this.http.get(url, {
      headers: this.getRequestHeaders(),
      observe: 'response',
      responseType: 'blob'
    }).pipe(map((response: any) => {
      return new Blob([response.body], {type: response.headers.get('Content-Type')});
    }));
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

}
